import React, { createContext, useContext, useState } from 'react';
import { Slide,Snackbar, Alert } from '@mui/material';

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
    // Function to handle the transition
    const SlideTransition = (props) => {
        return <Slide {...props} direction="left" />;
    };
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const showSnackbar = (message, severity = 'success') => {
        setSnackbar({
            open: true,
            message: message,
            severity: severity,
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            {snackbar.open && ( // Conditionally render the Snackbar
                <div
                    dir={localStorage.getItem('rtl') === 'ar' ? 'rtl' : 'ltr'}
                    style={{ direction: localStorage.getItem('rtl') === 'ar' ? 'rtl' : 'ltr' }}
                >
                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={6000}
                        onClose={handleCloseSnackbar}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: localStorage.getItem('rtl') === 'ar' ? 'left' : 'right',
                        }}
                        TransitionComponent={SlideTransition}
                        onExited={() => setSnackbar({ ...snackbar, message: '' })} // Reset message or perform cleanup
                    >
                        <Alert
                            onClose={handleCloseSnackbar}
                            severity={snackbar.severity}
                            sx={{
                                width: '100%',
                                py: 2,
                                fontSize: '1.25rem',
                                borderLeft: '5px solid',
                                borderColor:
                                    snackbar.severity === 'error'
                                        ? 'red'
                                        : snackbar.severity === 'warning'
                                            ? 'orange'
                                            : snackbar.severity === 'info'
                                                ? 'blue'
                                                : 'green',
                            }}
                        >
                            {snackbar.message}
                        </Alert>
                    </Snackbar>
                </div>
            )}
        </SnackbarContext.Provider>

    );
};

export const useSnackbar = () => useContext(SnackbarContext);
